import {
  HHBaseTable,
  HHCard,
  HHIconButton,
  HHIconButtonMenu,
  HHTypography,
} from '@hinge-health/react-component-library';
import CopyAllIcon from '@mui/icons-material/CopyAll';
import { formatCurrency } from '../../../../utils/currency-helpers';
import { cleanTypeNameGraphql } from '../../../../utils/graphql-utils';
import { SubmissionTypeDataList } from '../../bill-grid-components/bill-management-types';
import { SubmissionStatusCell } from '../../bill-grid-components/submission-status-cell';

export interface SelectedSubmissionsGridProps {
  selectedRows: SubmissionTypeDataList;
  setPanelSelectedRows: (selectedRows: SubmissionTypeDataList) => void;
}

export const SelectedSubmissionsGrid = ({
  selectedRows,
  setPanelSelectedRows,
}: SelectedSubmissionsGridProps): JSX.Element => {
  const handleDeleteRow = (rowId: number): void => {
    const rowsWithoutDeletedRow = selectedRows.filter(
      row => row.submissionId !== rowId,
    );
    setPanelSelectedRows(rowsWithoutDeletedRow);
  };

  return (
    <HHCard>
      {/* Adding copy icon to make it easier for RCM to qa release changes */}
      <HHIconButton
        hhVariant="medium"
        onClick={(): void => {
          navigator.clipboard.writeText(
            JSON.stringify(
              cleanTypeNameGraphql(
                selectedRows.map(row => ({
                  submissionId: row.submissionId,
                  submissionDate: row.submissionDate,
                  submissionAmount: row.submissionAmount,
                  submissionStatus: row.submissionStatus,
                  netsuiteId: row.netsuiteId,
                })),
              ),
              null,
              2,
            ),
          );
        }}
      >
        <CopyAllIcon />
        <HHTypography hhVariant="muted">Copy rows</HHTypography>
      </HHIconButton>
      <HHBaseTable
        headerRowBottomBorder="1px solid rgba(0, 0, 0, 0.12)"
        bodyRowBorder={{
          borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
        }}
        bodyTypographyVariant="body2"
        tableHeaders={[
          {
            value: 'Submission ID',
            align: 'left',
          },
          { value: 'Date', align: 'left' },
          { value: 'Amount', align: 'left' },
          { value: 'Netsuite ID', align: 'left' },
          { value: 'Status', align: 'left' },
        ]}
        bodyContent={selectedRows.map(row => ({
          submissionId: {
            value: row.submissionId ?? '--',
          },
          submissionDate: {
            value: row.submissionDate ?? '--',
          },
          submissionAmount: {
            value: row.submissionAmount
              ? formatCurrency(row.submissionAmount)
              : '--',
          },
          netsuiteId: {
            value: row.netsuiteId ?? '--',
          },
          submissionStatus: {
            value: row.submissionStatus ? (
              <SubmissionStatusCell submissionStatus={row.submissionStatus} />
            ) : (
              '--'
            ),
          },

          actions: {
            value:
              selectedRows.length <= 1 ? (
                ''
              ) : (
                <HHIconButtonMenu
                  aria-label="Grid action row menu"
                  role="menuitem"
                  menuItems={[
                    {
                      label: 'Remove from list',
                      onClick: () => handleDeleteRow(row.submissionId),
                    },
                  ]}
                />
              ),
          },
        }))}
      />
    </HHCard>
  );
};
